import { isExpired } from './subscription';
import { SpaceAccessStatus } from '@ppl/graphql-user-api';
import type { Space } from '@ppl/graphql-user-api';


export function canAccessSpace(space: Space) {
  return space && !space.isSuspended && !isExpired(space.subscription);
}

export function isIntercomEnabled(space: Space) {
  return space.settings.intercomIntegration;
}

export function getAvailableSpaceIdpId(space: Space) {
  return space.idp && space.idp.enabled ? space.idp.id : null;
}

export function getSpaceRegion(space: Space) {
  const hostname = new URL(space.graphqlUrl).hostname;

  const map = {
    'ap-southeast.pipelinersales.com': 'Asia Pacific (Sydney)',
    'ap-southeast-ajg.pipelinersales.com': 'Asia Pacific (Sydney - AJG)',
    'ca-central.pipelinersales.com': 'Canada (Central)',
    'eu-central.pipelinersales.com': 'Europe (Frankfurt)',
    'eu-west.pipelinersales.com': 'Europe (Ireland - stg1)',
    'stg2.pipelinersales.com': 'Europe (Ireland - stg2)',
    'us-east.pipelinersales.com': 'US East (N. Virginia)',
    'devel.pipelinersales.com': 'Devel',
    'devel-api.pipelinersales.com': 'Devel',
    'devel-crm5.pipelinersales.com': 'Devel 5',
    'devel-api5.pipelinersales.com': 'Devel 5'
  };

  return map[hostname] ? map[hostname] : hostname;
}

const spaceAccessRestrictedStatuses: SpaceAccessStatus[] = [
  SpaceAccessStatus.IdpLoginRequired,
  SpaceAccessStatus.TwoFARequired,
  SpaceAccessStatus.AccessFromRestrictedIP,
  SpaceAccessStatus.SessionReloginRequired
];

export function isSpaceAccessRestricted(space: Space): boolean {
  return spaceAccessRestrictedStatuses.includes(space.accessStatus);
}

